var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "193EAB36-18F3-46B7-B9A5-535ABD91D8B4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task-Cards",
    transform: "translate(-341.000000, -533.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "completed-task-card-copy",
    transform: "translate(24.000000, 508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock-icon",
    transform: "translate(317.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#4A4A4A",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4981517,0 C10.4555465,0 12.0350207,1.89949342 12.2365744,5.69848025 C13.020544,5.92249288 13.59375,6.64430672 13.59375,7.5 L13.59375,13.125 C13.59375,14.1605339 12.7542839,15 11.71875,15 L3.28125,15 C2.24571609,15 1.40625,14.1605339 1.40625,13.125 L1.40625,7.5 C1.40625,6.59866283 2.04223822,5.84586868 2.88993837,5.66589382 C3.01352023,1.88886102 4.54904555,0 7.4981517,0 Z M11.71875,6.5625 L3.28125,6.5625 C2.78701791,6.5625 2.3821101,6.94494271 2.34632144,7.43003328 L2.34375,7.5 L2.34375,13.125 C2.34375,13.6192321 2.72619271,14.0241399 3.21128328,14.0599286 L3.28125,14.0625 L11.71875,14.0625 C12.2129821,14.0625 12.6178899,13.6800573 12.6536786,13.1949667 L12.65625,13.125 L12.65625,7.5 C12.65625,7.00576791 12.2738073,6.6008601 11.7887167,6.56507144 L11.71875,6.5625 Z M7.5,7.96875 C8.27665043,7.96875 8.90625,8.59834957 8.90625,9.375 C8.90625,9.96344253 8.54482236,10.4674691 8.03184975,10.6771971 L8.03125,12.1875 C8.03125,12.4463835 7.80739237,12.65625 7.53125,12.65625 C7.27483208,12.65625 7.06349642,12.4752937 7.03461387,12.2421662 L7.03125,12.1875 L7.03116463,10.7012015 C6.4850253,10.5081291 6.09375,9.98725817 6.09375,9.375 C6.09375,8.59834957 6.72334957,7.96875 7.5,7.96875 Z M7.4981517,0.9375 C5.17462688,0.9375 3.97584047,2.32905153 3.83496241,5.4852057 L3.8296875,5.625 L11.295,5.625 L11.2872587,5.50461973 C11.0759107,2.39670996 9.87483876,0.987294649 7.61995739,0.938798055 L7.4981517,0.9375 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c116024f67209cf17457fb301046ed77.svg";
export { ForwardRef as ReactComponent };